<template>
  <div>
    <el-card shadow="always">
      <el-page-header
        v-if="id === ''"
        @back="back"
        title
        :content="$t('adicionar-novo-contrato')"
      ></el-page-header>
      <el-page-header
        v-if="id !== ''"
        @back="back"
        title
        :content="$t('atualizar-contrato')"
      ></el-page-header>
    </el-card>
    <el-dialog :title="$t('cartao-postagem')" :visible.sync="dialogFormVisible">
      <el-form :model="formCardPost">
        <el-form-item :label="$t('cartao-postagem')" prop="cardpost">
          <el-input
            ref="postofficeuser"
            v-model="formCardPost.cardpost"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('nome-cartao-postagem')" prop="name">
          <el-input v-model="formCardPost.name"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">Cancelar</el-button>
        <el-button
          v-show="!postoffice.valid"
          type="success"
          @click="getPostOffice()"
          >Testar</el-button
        >
        <el-button
          type="primary"
          v-show="postoffice.valid"
          @click="addCardPost()"
          >Salvar</el-button
        >
      </span>
    </el-dialog>
    <el-card>
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        label-position="top"
        :status-icon="true"
        :rules="rules"
        :inline-message="true"
      >
        <el-row :gutter="5">
          <el-col
            :xs="24"
            :sm="12"
            :md="12"
            :lg="12"
            :xl="12"
            v-if="user.type === '1' || user.type === '3'"
          >
            <el-form-item :label="$t('cliente')" prop="customer">
              <CustomerList
                v-model="ruleForm.customer"
                v-bind:current="ruleForm.customer"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :xs="24" :sm="10" :md="10" :lg="5" :xl="5">
            <el-form-item :label="$t('codigo')" prop="code">
              <el-input
                ref="code"
                :disabled="id !== ''"
                v-model="ruleForm.code"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="10" :md="10" :lg="8" :xl="8">
            <el-form-item :label="$t('nome')" prop="name">
              <el-input ref="name" v-model="ruleForm.name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="10" :md="10" :lg="8" :xl="3">
            <el-form-item :label="$t('ativo')" prop="active">
              <el-switch v-model="ruleForm.active"></el-switch>
            </el-form-item>
          </el-col>
        </el-row>
        <el-divider content-position="left">{{
          $t("dados-correios")
        }}</el-divider>
        <el-row :gutter="5">
          <el-col :xs="24" :sm="10" :md="10" :lg="6" :xl="6">
            <el-form-item :label="$t('id-contrato')" prop="contractid">
              <el-input
                ref="contractid"
                v-model="ruleForm.contractid"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="10" :md="10" :lg="6" :xl="6">
            <el-form-item :label="$t('usuario-correio')" prop="postofficeuser">
              <el-input
                ref="postofficeuser"
                v-model="ruleForm.postofficeuser"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="10" :md="10" :lg="6" :xl="6">
            <el-form-item label="Chave API" prop="postofficepassword">
              <el-input
                type="password"
                show-password
                ref="postofficepassword"
                v-model="ruleForm.postofficepassword"
              ></el-input>
            </el-form-item>
            <el-button type="warning" size="small" @click="contract()"
              >Validar</el-button
            >
          </el-col>
        </el-row>
        <br />
        <el-divider content-position="left"
          ><el-button
            type="primary"
            size="small"
            @click="addpost()"
            icon="el-icon-plus"
          ></el-button
          >&nbsp;
          {{ $t("cartao-postagem") }}
        </el-divider>
        <ul class="infinite-list">
          <li
            v-for="(record, index) of cardpost"
            v-bind:key="record.id"
            class="infinite-list-item"
            style="margin-bottom: 5px"
          >
            <el-button
              type="danger"
              size="small"
              @click="delCardPost(index)"
              icon="el-icon-delete"
            ></el-button
            >&nbsp;{{ record.code }}&nbsp;-&nbsp;{{ record.name }}
          </li>
        </ul>
        <br />
        <el-divider content-position="left">{{
          $t("dados-agencia")
        }}</el-divider>
        <el-row :gutter="5">
          <el-col :xs="24" :sm="10" :md="10" :lg="5" :xl="5">
            <el-form-item :label="$t('agf')" prop="agf">
              <el-input ref="agf" v-model="ruleForm.agf"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="10" :md="10" :lg="6" :xl="6">
            <el-form-item :label="$t('cnpj')" prop="federalId">
              <el-input
                ref="federalId"
                v-model="ruleForm.federalId"
                v-mask="'NN.NNN.NNN/NNNN-##'"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="16" :md="16" :lg="11" :xl="11">
            <el-form-item :label="$t('razao-social')" prop="companyname">
              <el-input
                ref="companyname"
                v-model="ruleForm.companyname"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <div v-if="user.type === '1'">
          <el-divider  content-position="left">Configurações do contrato</el-divider>
          <el-row :gutter="5">
            <el-col :xs="24" :sm="23" :md="23" :lg="24" :xl="24">
              <el-form-item>
                <el-checkbox v-model="ruleForm.pricetable">Não descontar o valor de custo do valor de tabela?</el-checkbox>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="5">
            <el-col :xs="24" :sm="23" :md="23" :lg="24" :xl="24">
              <el-form-item>
                <el-checkbox v-model="ruleForm.aditional">Cobrar os serviços adicionais da prepostagem</el-checkbox>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="5">
            <el-col :xs="24" :sm="23" :md="23" :lg="24" :xl="24">
              <el-form-item>
                <el-checkbox v-model="ruleForm.webhook">Utilizar webhook dos Correios</el-checkbox>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="5">
            <el-col :xs="24" :sm="23" :md="23" :lg="24" :xl="24">
              <el-form-item label="Valor Seguro">
                <el-radio-group v-model="ruleForm.insurance">
                  <el-radio label="maisenvios">Utilizar MaisEnvios</el-radio>
                  <el-radio label="courier">Utilizar Correios</el-radio>
                  <el-radio label="nocost">Não cobrar</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <el-divider content-position="left">Dados do endereço</el-divider>
        <el-row :gutter="5">
          <el-col :xs="14" :sm="6" :md="6" :lg="3" :xl="3">
            <el-form-item :label="$t('cep')" prop="zipcode">
              <el-input
                maxlength="9"
                v-model="ruleForm.cep"
                v-mask="'#####-###'"
                @blur="zipcode()"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="16" :md="16" :lg="11" :xl="11">
            <el-form-item :label="$t('endereco')" prop="address">
              <el-input v-model="ruleForm.address"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :xs="12" :sm="6" :md="6" :lg="3" :xl="3">
            <el-form-item :label="$t('bairro')" prop="neighborhood">
              <el-input v-model="ruleForm.neighborhood"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="9" :sm="9" :md="9" :lg="6" :xl="6">
            <el-form-item :label="$t('cidade')" prop="city">
              <el-input v-model="ruleForm.city"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="3" :sm="3" :md="3" :lg="2" :xl="2">
            <el-form-item :label="$t('estado')" prop="state">
              <el-input v-model="ruleForm.state"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :xs="12" :sm="6" :md="6" :lg="2" :xl="2">
            <el-form-item :label="$t('numero')" prop="number">
              <el-input
                type="number"
                maxlength="6"
                v-model="ruleForm.number"
                v-mask="'######'"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
            <el-form-item :label="$t('complemento')" prop="extent">
              <el-input v-model="ruleForm.extent"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :xs="12" :sm="6" :md="6" :lg="3" :xl="3">
            <el-form-item :label="$t('telefone')" prop="phone">
              <el-input ref="phone" v-model="ruleForm.phone"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="12" :sm="6" :md="6" :lg="3" :xl="3">
            <el-form-item :label="$t('celular')" prop="mobile">
              <el-input ref="mobile" v-model="ruleForm.mobile"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :xs="12" :sm="6" :md="6" :lg="6" :xl="6">
            <el-form-item
              :label="$t('codigo-administrativo-ect')"
              prop="codeect"
            >
              <el-input ref="codeect" v-model="ruleForm.codeect"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="12" :sm="6" :md="6" :lg="6" :xl="6">
            <el-form-item :label="$t('senha-ect')" prop="passwordect">
              <el-input
                type="password"
                ref="passwordect"
                v-model="ruleForm.passwordect"
                show-password
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!--el-row gutter="5">
          <el-col :xs="12" :sm="6" :md="6" :lg="3" :xl="3">
            <el-form-item :label="$t('contrato')" prop="name">
              <el-input ref="name" v-model="ruleForm.name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="12" :sm="6" :md="6" :lg="3" :xl="3">
            <el-form-item :label="$t('regional')" prop="name">
              <el-input ref="name" v-model="ruleForm.name"></el-input>
            </el-form-item>
          </el-col>
        </!--el-row-->
        <br />
        <el-form-item style="text-align: center">
          <el-button
            type="warning"
            v-if="id === ''"
            autofocus
            @click="submitForm('ruleForm')"
            >{{ $t("adicionar") }}</el-button
          >
          <el-button
            type="warning"
            v-if="id !== ''"
            autofocus
            @click="editForm('ruleForm')"
            >{{ $t("atualizar") }}</el-button
          >
          <el-button @click="back()">{{ $t("voltar") }}</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>
<script>
import { i18n } from "@/plugin/i18n";
import { ContractService } from "@/services/customers/contract.services";
import { PostOfficeService } from "@/services/post.office/post.office.services";
import { UserService } from "@/services/users/user.services";
import CustomerList from "@/xpost/views/register/customer/CustomerList";
import ZipMixins from "../../../mixins/zipcode";

export default {
  name: "ContractAdd",
  mixins: [ZipMixins],
  components: {
    CustomerList,
  },
  data() {
    return {
      id: "",
      dialogFormVisible: false,

      postoffice: {
        valid: false,
        card: "",
        contractid: "",
        user: "",
        password: "",
      },
      formCardPost: {
        cardpost: "",
        name: "",
        contractid: "",
        postofficeuser: "",
        postofficepassword: "",
      },
      rulesCard: {
        cardpost: [
          {
            required: true,
            message: i18n.tc("campo-obrigatorio"),
            trigger: "blur",
          },
        ],
        contractid: [
          {
            required: true,
            message: i18n.tc("campo-obrigatorio"),
            trigger: "blur",
          },
        ],
        postofficeuser: [
          {
            required: true,
            message: i18n.tc("campo-obrigatorio"),
            trigger: "blur",
          },
        ],
        postofficepassword: [
          {
            required: true,
            message: i18n.tc("campo-obrigatorio"),
            trigger: "blur",
          },
        ],
      },
      cardpost: [],
      user: { type: "2'" },
      ruleForm: {
        name: "",
        code: "",
        cardpost: "",
        customer: "",
        contractid: "",
        postofficeuser: "",
        postofficepassword: "",
        passwordect: "",
        codeect: "",
        passwordsvp: "",
        usersvp: "",
        key: "",
        ftpectuser: "",
        ftpectpassword: "",
        reversePassword: "",
        reverseUser: "",
        customerml: "",
        codeml: "",
        password: "",
        mail: "",
        port: 0,
        host: "",
        contract: "",
        mobile: "",
        phone: "",
        companyname: "",
        address: "",
        cep: "",
        city: "",
        state: "",
        neighborhood: "",
        number: "",
        extent: "",
        federalId: "",
        agf: "",
        active: true,
        insurance: 'maisenvios', 
        aditional: true,
        webhook: true,
      },
      list: [],
      rules: {
        name: [
          {
            required: true,
            message: i18n.tc("nome-obrigatorio"),
            trigger: "blur",
          },
        ],
        code: [
          {
            required: true,
            message: i18n.tc("codigo-obrigatorio"),
            trigger: "blur",
          },
        ],
        cardpost: [
          {
            required: true,
            message: i18n.tc("campo-obrigatorio"),
            trigger: "blur",
          },
        ],
        contractid: [
          {
            required: true,
            message: i18n.tc("campo-obrigatorio"),
            trigger: "blur",
          },
        ],
        postofficeuser: [
          {
            required: true,
            message: i18n.tc("campo-obrigatorio"),
            trigger: "blur",
          },
        ],
        postofficepassword: [
          {
            required: true,
            message: i18n.tc("campo-obrigatorio"),
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    back() {
      var vm = this;
      vm.$router.push("/cadastro/contrato").catch(() => {});
    },
    addpost() {
      const vm = this;
      vm.formCardPost.cardpost = "";
      vm.formCardPost.name = "";
      vm.formCardPost.contractid = vm.ruleForm.contractid;
      vm.formCardPost.postofficeuser = vm.ruleForm.postofficeuser;
      vm.formCardPost.postofficepassword = vm.ruleForm.postofficepassword;
      vm.dialogFormVisible = true;
    },
    delCardPost(index) {
      const vm = this;
      vm.cardpost.splice(index, 1);
    },
    contract() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      ContractService.validate({
        username: vm.ruleForm.postofficeuser,
        apikey: vm.ruleForm.postofficepassword,
        contract: vm.ruleForm.contractid,
      })
        .then((response) => {
          console.log("response", response);
          vm.ruleForm.federalId = response.federalid;
          vm.ruleForm.codeect = response.administrative;
          vm.list = response.cardpost;
          vm.$message({
            type: "success",
            message: "Contrato validado no Correio!",
          });
        })
        .catch((error) => {
          vm.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    },
    getPostOffice() {
      const vm = this;
      const cardpost = vm.list.find((x) => +x.id === +vm.formCardPost.cardpost);
      if (!cardpost) {
        return vm.$message({
          type: "error",
          message: "Cartão de postagem não relacionado nesse contrato!",
        });
      }
      vm.postoffice.valid = true;
    },
    addCardPost() {
      const vm = this;
      const record = vm.cardpost.find(
        (x) => x.code == vm.formCardPost.cardpost
      );
      if (record) {
        return vm.$message({
          type: "error",
          message: "Cartão já relacionado a esse contrato",
        });
      }
      vm.dialogFormVisible = false;
      vm.ruleForm.contractid = vm.formCardPost.contractid;
      vm.ruleForm.user = vm.formCardPost.postofficeuser;
      vm.ruleForm.password = vm.formCardPost.postofficepassword;
      vm.cardpost.push({
        id: null,
        code: vm.formCardPost.cardpost,
        name: vm.formCardPost.name,
      });
    },
    get() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      ContractService.get(vm.id)
        .then((response) => {
          vm.id = response.id;
          vm.ruleForm = response;
          vm.cardpost = response.cardpost;
          vm.ruleForm.cep = response.zipcode.zipcode;
          vm.ruleForm.address = response.zipcode.address;
          vm.ruleForm.city = response.zipcode.city;
          vm.ruleForm.state = response.zipcode.state;
          vm.ruleForm.neighborhood = response.zipcode.neighborhood;
          vm.ruleForm.webhook = true;
        })
        .catch((error) => {
          vm.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    },
    validate() {
      const vm = this;
      if (!vm.ruleForm.code) {
        vm.$message({
          type: "error",
          message: i18n.tc("codigo-obrigatorio"),
        });
        return false;
      }
      if (!vm.ruleForm.name) {
        vm.$message({
          type: "error",
          message: i18n.tc("nome-obrigatorio"),
        });
        return false;
      }
      if (!vm.postoffice) {
        vm.$message({
          type: "error",
          message: i18n.tc("dados-correio-nao-validos"),
        });
        return false;
      }
      return true;
    },
    submitForm(formName) {
      const vm = this;
      if (vm.validate()) {
        const loading = vm.$loading(vm.$options.loading);
        ContractService.add(vm.ruleForm, vm.cardpost)
          .then((response) => {
            this.$message({
              type: "success",
              message: i18n.tc("contrato-adicionado-sucesso"),
            });
            this.$refs[formName].resetFields();
          })
          .catch((error) => {
            this.$message({
              type: "error",
              message: error,
            });
          })
          .finally(() => loading.close());
      }
    },
    editForm(formName) {
      const vm = this;
      vm.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = vm.$loading(vm.$options.loading);
          ContractService.update(vm.id, vm.ruleForm, vm.cardpost)
            .then((response) => {
              this.$message({
                type: "success",
                message: i18n.tc("contrato-atualizado-sucesso"),
              });
            })
            .catch((error) => {
              this.$message({
                type: "error",
                message: error,
              });
            })
            .finally(() => loading.close());
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
  mounted() {
    const vm = this;
    UserService.me()
      .then((response) => {
        vm.user.type = response.type;
        if (this.$route.params.id) {
          this.id = this.$route.params.id;
          vm.get();
        } else {
          vm.$refs.code.$el.children[0].focus();
        }
      })
      .catch((error) => {
        vm.$message({
          type: "error",
          message: error,
        });
      });
  },
};
</script>
<style scoped>
.infinite-list {
  list-style: none;
}
</style>
